@if (hasVideoScheduledPublication()) {
  <my-alert type="primary" i18n>
  This video will be published on {{ video().scheduledUpdate.updateAt | ptDate: 'full' }}.
</my-alert>
}

@if (isWaitingForLive()) {
  <my-alert type="primary">
    <div i18n>This live is not currently streaming.</div>
    @if (scheduledLiveDate()) {
      <div i18n>
      It will start on {{ scheduledLiveDate() | ptDate: 'short' }}.
    </div>
    }
  </my-alert>
}

@if (isLiveEnded()) {
  <my-alert type="primary" i18n>
  This live has ended.
</my-alert>
}

@if (getAlertWarning()?.title) {
  <my-alert type="warning">
    <div class="alert-title">{{ getAlertWarning()?.title }}</div>

    @if (canSeeMoreStateInfo()) {
      {{ getAlertWarning().watchSecondary }}
    }

    {{ getAlertWarning().watchMain }}
  </my-alert>
}

@if (getAlertError()?.title) {
  <my-alert type="danger">
    <div class="alert-title">{{ getAlertError()?.title }}</div>

    {{ getAlertError().main }}
  </my-alert>
}

@if (noPlaylistVideoFound()) {
  <my-alert i18n type="warning">
  There are no videos available in this playlist.
</my-alert>
}

@if (video()?.canBypassPassword(user())) {
  <my-alert i18n type="warning">
  This video is password protected.
</my-alert>
}
